import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SiteText from './SiteText.jsx'
import logo from './assets/logo.png';
import Styles from './Styles.jsx';
import DropDownMenu from './DropDownMenu.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef } from "react";

const NavBar = () => {
    const navigate = useNavigate();
    const [ navButtonUsed, setNavButtonUsed ] = useState(false);
    const [ expandedServices, setExpandedServices ] = useState(false);
    const items = Object.values(SiteText.NavBar.Bottom.Services.DropDownMenuText);
    const smallScreenNavigationRef = useRef(null);
    const smallScreenServicesButtonRef = useRef(null);

    return <div className={`flex flex-col fixed ${navButtonUsed ? "max-lg:h-[55vh]" : ""} w-screen`}>
        <div className="bg-primary py-1 text-tertiary flex justify-between">
            <div className="px-4">
                {SiteText.Global.Contact.Email}
            </div>
            <div className="px-4">
                {SiteText.Global.Contact.Phone}
            </div>
        </div>
        <div className="flex bg-secondary justify-between items-center">
            <div className="w-1/2 sm:w-1/3">
                <button
                    onClick={() => navigate(SiteText.SitePaths.Home)}
                >
                    <img 
                        src={logo} 
                        alt="Elite Power Wash Logo" 
                        className="object-contain h-[9vh] pl-4 py-1"
                    />
                </button>
            </div>
            <div className="max-lg:hidden flex lg:w-1/3 justify-around items-center">
                <button className={Styles.NavBar.Button} onClick={() => navigate(SiteText.SitePaths.Home)}>
                    {SiteText.NavBar.Bottom.Home}    
                </button>
                <DropDownMenu 
                    className={Styles.NavBar.Button}
                    displayText={SiteText.NavBar.Bottom.Services.Title} 
                />
                <button 
                    className={Styles.NavBar.Button}
                    onClick={() => navigate(SiteText.SitePaths.GetQuote)}
                >
                    {SiteText.NavBar.Bottom.GetQuote}
                </button>
                <button className={Styles.NavBar.Button} onClick={() => navigate(SiteText.SitePaths.About)}>
                    {SiteText.NavBar.Bottom.AboutUs}
                </button>
            </div>
            <div className="lg:w-1/3">
                <button
                    className="hover:bg-tertiary "
                    onClick={() => {setNavButtonUsed(!navButtonUsed)}}
                >
                    <FontAwesomeIcon 
                        icon={`fa-solid ${navButtonUsed ? "fa-x" : "fa-bars"}`}
                        className="lg:hidden text-3xl h-24 px-8 text-primary"
                    />
                </button>
            </div>
        </div>
        <div ref={smallScreenNavigationRef} className={`w-screen bg-secondaryDark ${navButtonUsed ? "" : "hidden"} overflow-auto`}>
                <button className={Styles.NavBar.ButtonAlt} onClick={() => navigate(SiteText.SitePaths.Home)}>
                    {SiteText.NavBar.Bottom.Home}    
                </button>
                <button 
                    className={Styles.NavBar.ButtonAlt}
                    onClick={() => navigate(SiteText.SitePaths.GetQuote)}
                >
                    {SiteText.NavBar.Bottom.GetQuote}
                </button>
                <button 
                    ref={smallScreenServicesButtonRef}
                    className={Styles.NavBar.ButtonAlt} 
                    onClick={() => {
                        setExpandedServices(!expandedServices)
                        setTimeout(() => {
                            smallScreenNavigationRef.current?.scrollBy(0, 200);
                        }, 0);
                    }}
                >
                    {SiteText.NavBar.Bottom.Services.Title}
                    <FontAwesomeIcon 
                        icon={`fa-solid ${expandedServices ? "fa-caret-up" : "fa-caret-down"}`}
                        className="lg:hidden px-2 text-primary"
                    />
                    <div className={`${expandedServices ? "" : "hidden"}`}>
                        {items.map((item, index) => {
                            return <button 
                                    key={index}
                                    className={Styles.NavBar.DropDownMenu.MenuItemAlt}
                                    onClick={() => navigate(SiteText.SitePaths.Service + item.replaceAll(" ", "-").toLowerCase())}    
                                >
                                    {item}    
                            </button>
                        })}
                    </div>
                </button>
                <button 
                    className={Styles.NavBar.ButtonAlt} 
                    onClick={() => navigate(SiteText.SitePaths.About)}
                >
                    {SiteText.NavBar.Bottom.AboutUs}
                </button>
        </div>
    </div>
};

export default NavBar